// YERİ: src/app/domains/website/sections/mkt-icon.ts
//
// Vitrinin ikonları. Paylaşımlı <m-icon> KULLANILMIYOR, çünkü onun Lucide
// sprite'ı `provideMIcons` içinde SUNUCUDA ATLANIR — SSR HTML'inde <use href>
// hiçbir şeye çözülmez ve ikonlar ilk boyamada görünmez. Vitrinde ikonlar
// içeriğin parçası; boş bir <use> ile açılan bir sayfa ucuz görünür.
//
// Emoji de kullanmıyoruz (önce öyleydi): platformdan platforma değişir,
// ölçeklenmez, renk alamaz ve amatör durur.
//
// Çözüm: yol verisi burada, doğrudan inline <svg> olarak çizilir. Sunucu
// HTML'inde hazır gelir. Yollar Lucide'dan (ISC lisansı).

import { Component, computed, input } from '@angular/core';

/** Lucide yolları — stroke tabanlı, 24x24 viewBox. */
const PATHS: Record<string, string> = {
  // Sektörler
  restaurant:   'M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2M7 2v20M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7',
  hotel:        'M2 20h20M4 20V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12M9 20v-4h6v4M8 10h.01M12 10h.01M16 10h.01',
  clinic:       'M11 2v4H7v4h4v4h2v-4h4V6h-4V2h-2ZM4 22V10a8 8 0 0 1 16 0v12',
  dental:       'M12 5.5c-1.5-1.5-3-2-4.5-1.5C6 4.5 5 6 5 8c0 2.5.5 5 1 8 .4 2.2 1 4 2 4s1.5-1.5 2-4c.3-1.5.6-2 1-2s.7.5 1 2c.5 2.5 1 4 2 4s1.6-1.8 2-4c.5-3 1-5.5 1-8 0-2-1-3.5-2.5-4-1.5-.5-3 0-4.5 1.5Z',
  pharmacy:     'm10.5 20.5-7-7a5 5 0 0 1 7-7l7 7a5 5 0 0 1-7 7ZM8.5 8.5l7 7',
  vet:          'M11 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM18 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM12 11c-2.5 0-4 2-5 4-.8 1.6 0 3 1.5 3 1 0 2-.5 3.5-.5s2.5.5 3.5.5c1.5 0 2.3-1.4 1.5-3-1-2-2.5-4-5-4Z',
  law:          'M12 3v18M8 21h8M3 7l4-4 4 4M3 7l2 5h4l2-5M13 7l4-4 4 4M13 7l2 5h4l2-5',
  immigration:  'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20Z',
  consulting:   'M3 20h18M6 20V10M11 20V4M16 20v-7M21 20V8',
  education:    'm22 9-10-5L2 9l10 5 10-5ZM6 11v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5',
  daycare:      'M9 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM9 16s1.2 1.5 3 1.5 3-1.5 3-1.5M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z',
  beauty:       'm14 4 6 6-9 9H5v-6l9-9ZM11 7l6 6M3 21h8',
  fitness:      'M6 6v12M18 6v12M3 9v6M21 9v6M6 12h12',
  sports:       'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM12 8l4 3-1.5 5h-5L8 11l4-3ZM12 2v6M4 8l4 3M20 8l-4 3M7.5 20l2-4M16.5 20l-2-4',
  realty:       'm3 10 9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V10ZM9 22V12h6v10',
  construction: 'M2 20h20M5 20V9l7-5 7 5v11M9 20v-6h6v6',
  homeservices: 'M14.7 6.3a4 4 0 0 1 5 5L20 12l-8 8-4-4 8-8 .3-.3ZM6 22l-4-4 4-4',
  automotive:   'M5 17h14M6 17v2M18 17v2M4 13l1.5-5A2 2 0 0 1 7.4 6.5h9.2a2 2 0 0 1 1.9 1.5L20 13M4 13h16v4H4v-4ZM7 15h.01M17 15h.01',
  logistics:    'M3 7h11v9H3zM14 10h4l3 3v3h-7M6.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
  storage:      'M3 4h18v6H3zM3 14h18v6H3zM8 7h.01M8 17h.01',
  property:     'M3 21h18M5 21V6l7-3 7 3v15M9 21v-5h6v5M9 10h.01M15 10h.01',
  events:       'M12 2 3 7l9 5 9-5-9-5ZM3 12l9 5 9-5M3 17l9 5 9-5',
  agency:       'M12 2 2 7v10l10 5 10-5V7l-10-5ZM12 12 2 7M12 12v10M12 12l10-5',
  creator:      'm10 8 6 4-6 4V8ZM3 5h18v14H3z',
  ngo:          'M20.8 6.6a5 5 0 0 0-7.1 0L12 8.3l-1.7-1.7a5 5 0 1 0-7.1 7.1l8.8 8.8 8.8-8.8a5 5 0 0 0 0-7.1Z',
  faith:        'M12 2v20M8 6h8M4 22V11l8-6 8 6v11',
  agriculture:  'M12 22V8M12 8c0-3 2-6 5-6 0 3-2 6-5 6ZM12 12c0-3-2-6-5-6 0 3 2 6 5 6ZM4 22h16',
  booking:      'M8 2v4M16 2v4M3 8h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM9 14h2v2H9z',
  wellness:     'M19 14c1.5-1.5 2-3.5 2-5a5 5 0 0 0-9-3 5 5 0 0 0-9 3c0 1.5.5 3.5 2 5l7 7 7-7Z',
  fnb:          'M17 8h1a4 4 0 1 1 0 8h-1M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V8ZM6 2v3M10 2v3M14 2v3',
  web:          'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20Z',
  sparkles:     'm12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3ZM19 17l.9 2.1L22 20l-2.1.9L19 23l-.9-2.1L16 20l2.1-.9L19 17Z',

  // Genel
  check:        'M20 6 9 17l-5-5',
  arrow:        'M5 12h14M13 5l7 7-7 7',
  shield:       'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10ZM9 12l2 2 4-4',
  zap:          'M13 2 3 14h9l-1 8 10-12h-9l1-8Z',
  lock:         'M5 11h14v10H5zM8 11V7a4 4 0 1 1 8 0v4',
  globe:        'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 12h20M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20Z',
};

@Component({
  selector: 'mkt-icon',
  standalone: true,
  host: { class: 'inline-flex shrink-0' },
  template: `
    <svg [attr.width]="px()" [attr.height]="px()" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="1.75"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path [attr.d]="path()" />
    </svg>
  `,
})
export class MktIcon {
  readonly name = input.required<string>();
  readonly size = input<number>(20);

  protected px = computed(() => this.size());
  protected path = computed(() => PATHS[this.name()] ?? PATHS['sparkles']);
}

/** CMS'te seçilebilecek ikonlar — şema bunu kullanır. */
export const MKT_ICON_NAMES = Object.keys(PATHS);
